import { Component, OnInit } from '@angular/core';

import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.page.html',
  styleUrls: ['./email-confirmation.page.scss'],
})
export class EmailConfirmationPage implements OnInit {
  user;
  checkUser;

  constructor(private auth: AuthService) {}

  ngOnInit() {
    this.auth.getUser().then((user) => {
      this.user = user;
    });
  }

  ionViewDidEnter() {
    this.getUserFromServer();
    this.checkUser = setInterval(() => {
      this.getUserFromServer();
    }, 10000);
  }

  ionViewDidLeave() {
    clearInterval(this.checkUser);
  }

  getUserFromServer() {
    this.auth.getUserFromServer().then((user) => {
      this.auth.redirectTo(user);
    });
  }

  logout() {
    this.auth.logout();
  }

  resend() {
    this.auth.resendMail();
  }
}
